<h2 class="title heavy-header-text" mat-dialog-title>{{ dialog.title }}</h2>
<mat-dialog-content class="centered">
  <ng-container *ngFor="let message of dialog.messageList">
    <p class="confirm header-text">{{ message }}</p>
  </ng-container>
  <ng-container *ngIf="dialog.showOpenField">
    <textarea
      name="dialog-input"
      required="true"
      [ngModel]="openFieldValue"
      (ngModelChange)="openFieldChange($event)"
      [placeholder]="dialog.openFieldPlaceholder"
    ></textarea>
  </ng-container>
  <ng-container *ngIf="dialog.showBlock">
    <app-block-viewer class="block" [block]="block"></app-block-viewer>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions class="centered">
  <app-confirm-cancel
    [buttonConfig]="dialog.submit"
    (emitSubmit)="submit()"
    [disableSubmit]="disableSubmit"
    [showBlock]="dialog.showBlock"
  >
  </app-confirm-cancel>
</mat-dialog-actions>
